// PALMEX · Größentabelle (blocks/px-groessentabelle.liquid): öffnet das Fenster, hebt die gewählte Größe hervor und
// springt auf Wunsch zu Foto-Fit. Über Ereignis-Delegation, damit es auch nach Horizons Neuaufbau beim Variantenwechsel
// greift. Schließen über Knopf, Escape (nativ) oder Klick neben das Fenster.
const gewaehlteGroessen = () => {
  const werte = new Set();
  document.querySelectorAll('variant-picker input[type="radio"]:checked').forEach((e) => werte.add(String(e.value).toUpperCase()));
  document.querySelectorAll('variant-picker select').forEach((e) => werte.add(String(e.value).toUpperCase()));
  return werte;
};

if (!window.pxGroessentabelle) {
  window.pxGroessentabelle = true;
  document.addEventListener('click', (event) => {
    const ziel = /** @type {HTMLElement} */ (event.target);
    const oeffnen = ziel.closest?.('[data-px-gt-oeffnen]');
    if (oeffnen) {
      const fenster = /** @type {HTMLDialogElement | null} */ (oeffnen.closest('.px-gt')?.querySelector('dialog'));
      if (!fenster) return;
      const werte = gewaehlteGroessen();
      fenster.querySelectorAll('tr[data-px-gt-groesse]').forEach((zeile) => {
        zeile.classList.toggle('px-gt--gewaehlt', werte.has(/** @type {HTMLElement} */ (zeile).dataset.pxGtGroesse || ''));
      });
      const fotofit = /** @type {HTMLElement | null} */ (fenster.querySelector('[data-px-gt-fotofit]'));
      if (fotofit) fotofit.hidden = !document.querySelector('[data-px-ff-oeffnen]');
      fenster.showModal();
      fenster.querySelector('.px-gt--gewaehlt')?.scrollIntoView({ block: 'nearest' });
      return;
    }
    const fenster = /** @type {HTMLDialogElement | null} */ (ziel.closest?.('.px-gt-fenster'));
    if (!fenster) return;
    if (ziel === fenster || ziel.closest('[data-px-gt-zu]')) {
      fenster.close();
    } else if (ziel.closest('[data-px-gt-fotofit]')) {
      fenster.close();
      /** @type {HTMLElement | null} */ (document.querySelector('[data-px-ff-oeffnen]'))?.click();
    }
  });
}
